/**
 * 
 * 
 * 
 * 
 */
import dayjs from 'dayjs'

/**
 * 
 */
export const lifeExpectancy = {
  China: { male: 75, female: 78 }
}

export const ageBracket = {
  1950: [
    '西藏解放', '抗美援朝', '第一部宪法', '计划生育', 
    '武汉长江大桥', '汉语拼音颁布', '大跃进', '人民大会堂落成'
  ],
  1960: [
    '登顶珠峰', '向雷锋同志学习', '上山下乡', '毛泽东语录', 
    '原子弹氢弹', '西藏自治区成立', '文化大革命', '天安门事件', 
    '南京长江大桥', '刘少奇去世'
  ],
  1970: [
    '东方红1号', '长征一号', '林彪事件', '四人帮', 
    '唐山大地震', '彭德怀去世', '周恩来逝世', '朱德逝世', 
    '毛泽东逝世', '恢复高考', '四项基本原则', '小康社会', '中美建交'
  ],
  1980: [
    '五讲四美运动', '一国两制首次提出', '建设有中国特色社会主义','首届春晚',
    '许海峰奥运金牌', '计划生育基本国策', '大兴安岭火灾',
    '香港特区基本法草案', '戈尔巴乔夫访华', '希望工程'
  ],
  1990: [
    '北京亚运会', '香港特区基本法通过', '上海证交所成立', '秦山核电站并网发电', 
    '邓小平南巡', '三峡工程', '甲A联赛', '双休日', '香港回归', '建国50周年',
    '澳门回归'
  ],
  2000: [
    '北京奥运会', '青藏铁路', '南水北调', '抗击非典', '神舟六号载人飞行', 
    '八荣八耻', '中美撞机事件', '男足首进世界杯', '博鳌论坛', '超级女声',
    '三鹿奶粉事件', '建国60周年', '汶川地震'
  ],
  2010: [
    '上海世博会', '天宫一号', '莫言', '屠呦呦与青蒿素', '4G', '共享经济', 
    '移动支付', '互联网+', '5G', '建国70周年'
  ]
}

/**
 * 
 * 
 */
export const colors = [
  '#FFEBEE','#EF9A9A',
  '#FCE4EC','#F48FB1',
  '#E1BEE7','#F3E5F5',
  '#C5CAE9', '#9FA8DA',
  '#BBDEFB', '#64B5F6',
  '#B3E5FC', '#29B6F6',
  '#B2DFDB', '#4DB6AC',
  '#C8E6C9', '#66BB6A',
  '#F0F4C3', '#D4E157',
  '#69F0AE', '#00C853',
  '#FFCC80', '#FF8A65',
  '#CFD8DC', '#B0BEC5'
]

/**
 *
 *
 * @export
 * @param {number} [born=1990]
 * @param {number} [sexy=0]
 * @param {string} [country='China']
 * @returns
 */
export function getLivesCountByYear(born = 1990, maxLifeTime) {
  const nowDate = dayjs()
  //
  const targetDate = dayjs(born + '-12-31').add(maxLifeTime, 'years')
  //
  const diffHour = targetDate.diff(nowDate, 'hours') % 24
  const diffMin = targetDate.diff(nowDate, 'minutes') % 60
  const diffSec = targetDate.diff(nowDate, 'seconds') % 60

  return {
    year: targetDate.diff(nowDate, 'year'),
    month: targetDate.diff(nowDate, 'month') % 12,
    day: targetDate.diff(nowDate, 'day') % 365,
    hour: diffHour < 10 ? '0' + diffHour : diffHour,
    minute: diffMin < 10 ? '0' + diffMin : diffMin,
    second: diffSec < 10 ? '0' + diffSec : diffSec
  }
}

/**
 * 
 * @param {*} expectancyYear 
 * @param {*} maxLifeTime 
 */
export function getBatteryPercent (expectancyYear, maxLifeTime) {
  return  expectancyYear / maxLifeTime
}

/**
 * 
 * @param {*} fn 
 * @param {*} time 
 */
export function debounce(fn, time) {
  let timeout;
  return function () {
    if( timeout ) clearTimeout(timeout)
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
    },time)
  }
}

/**
 * 
 * @param {*} fn 
 * @param {*} time 
 */
export function throttle(fn, time) {
  let timeout
  let remaining = 0
  let prevTime = new Date()
  return function () {
    let nowTime = new Date().getTime()
        remaining = nowTime - prevTime
    if (remaining > time) {
      if (timeout) {
        clearTimeout(timeout)
      }
      prevTime = nowTime
      fn.apply(this, arguments)
    } else {
      if (!timeout) {
        timeout = setTimeout(() => {
          fn.apply(this, arguments)
          prevTime = new Date()
        }, time - remaining)
      }
    }
  }
}